/**
 * Add New User Form
 */
import React from 'react';
import { Form, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Switch from '@material-ui/core/Switch';

const AddNewDocumentForm = ({ addNewDocumentDetails, onChangeAddNewDocumentDetails, validate }) => (
    <Form>
        <FormGroup>
            <Label for="name">Nombre</Label>
            <Input
                type="text"
                name="name"
                id="name"
                invalid={validate.nameState === "has-danger"}
                placeholder="Ingrese Nombre"
                value={addNewDocumentDetails.name}
                onChange={(e) => onChangeAddNewDocumentDetails('name', e.target.value)}
            />
            <FormFeedback>
              Nombre no puede ser vacío o muy corto.
            </FormFeedback>
        </FormGroup>
        <FormGroup>
            <Label className="mb-1" for="acceso_sistema">Requerido</Label>
            <FormControl fullWidth>
                <Switch name="requerido" color="primary" id="requerido" checked={(addNewDocumentDetails.requerido === 1 || addNewDocumentDetails.requerido === true) ? true : false } 
                onChange={(e) => onChangeAddNewDocumentDetails('requerido', e.target.checked)} aria-label="requerido" />
              </FormControl>
        </FormGroup>
        <FormGroup>
            <Label for="expirated_at">Días previos de aviso (0 para no notificar)</Label>
            <Input
                type="number"
                name="expirated_at"
                id="expirated_at"
                value={addNewDocumentDetails.expirated_at}
                onChange={(e) => onChangeAddNewDocumentDetails('expirated_at', e.target.value)}
            />
        </FormGroup>
        <FormGroup>
            <Label className="mb-1" for="estado">Estado</Label>
            <FormControl fullWidth>
                <Select name="estado" name="estado" value={addNewDocumentDetails.estado} onChange={(e) => onChangeAddNewDocumentDetails('estado', e.target.value)}
                >
                      <MenuItem value={1}>Habilitado</MenuItem>
                      <MenuItem value={0}>Deshabilitado</MenuItem>
                </Select>
              </FormControl>
        </FormGroup>
    </Form>
);

export default AddNewDocumentForm;